import React, { useState } from "react";
import Login from "./Login";
import Register from "./Register";
import ProjectApp from "./ProjectApp";

function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [showRegister, setShowRegister] = useState(false);

  const handleLogin = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    setUser(null);
  };

  if (user) {
    return <ProjectApp user={user} onLogout={handleLogout} />;
  }

  return (
    <>
      {showRegister ? (
        <Register
          onRegistered={() => setShowRegister(false)}
          onToggle={() => setShowRegister(false)}
        />
      ) : (
        <Login
          onLogin={handleLogin} // 👈 Pasamos los datos del usuario logueado
          onToggle={() => setShowRegister(true)}
        />
      )}
    </>
  );
}

export default App;